import { CURRENCY_MAP } from '../constants';

export const THINSP = String.fromCharCode(8201);
export const AMOUNT_MAJOR_MINOR_PARTS_SEPARATOR = ',';

const AMOUNT_MAJOR_PARTS_SPLITTER = THINSP;
const AMOUNT_MAJOR_PART_SIZE = 3;
const AMOUNT_SPLIT_CODE_FROM = 4;
const NEGATIVE_AMOUNT_SYMBOL = '−';

const getCurrencySymbol = currencyCode => {
  return CURRENCY_MAP[currencyCode] || currencyCode;
};

const splitAmount = (amount, partSize = 3, splitter = THINSP, splitFrom = 5) => {
  const len = amount.length;

  if (len < splitFrom) {
    return amount;
  }

  return amount
    .split('')
    .reduce((acc, item, i) => {
      const isLastItem = i !== len - 1;
      // eslint-disable-next-line no-mixed-operators
      const isStartOfPart = (i - (len % partSize) + 1) % partSize === 0;

      return isLastItem && isStartOfPart ? [...acc, item, splitter] : [...acc, item];
    }, [])
    .join('');
};

export const formatAmount = amount => {
  const {
    value,
    currency: { code },
  } = amount;

  let { minority } = amount.currency;

  minority = minority === 0 ? 1 : minority; // because Math.log(0) => -Infinity

  const fractionDigits = Math.log(minority) * Math.LOG10E;
  const valueAbsStr = (Math.abs(value) / minority).toFixed(fractionDigits);

  const [majorPart, minorPart] = valueAbsStr.split('.');

  const majorPartSplitted = splitAmount(
    majorPart,
    AMOUNT_MAJOR_PART_SIZE,
    AMOUNT_MAJOR_PARTS_SPLITTER,
    AMOUNT_SPLIT_CODE_FROM,
  );

  const majorPartFormatted =
    value < 0 ? NEGATIVE_AMOUNT_SYMBOL + majorPartSplitted : majorPartSplitted;

  const formattedValueStr = minorPart
    ? majorPartFormatted + AMOUNT_MAJOR_MINOR_PARTS_SEPARATOR + minorPart
    : majorPartFormatted;

  return {
    majorPart: majorPartFormatted,
    minorPart,
    value: formattedValueStr,
    currencySymbol: getCurrencySymbol(code),
  };
};
